// extracted by mini-css-extract-plugin
export default {"container":"RouteCompletedAlert_container__2I6aq","text":"RouteCompletedAlert_text__qKkMo"};